export class FilterMethodBuilder {
    form: FormFilters = new FormFilters();
}

class FormFilters {
    filterStartDate(propName:string, date:Date){
        return (record:any)=>{
            const obj = record.data;
            const objDate = new Date(obj[propName]?.split('T')[0]);

            return objDate >= date
        };
    }
    filterEndDate(propName:string, date:Date){
        return (record:any)=>{
            const obj = record.data;
            const objDate = new Date(obj[propName]?.split('T')[0]);

            return objDate <= date
        };
    }
    filterIsOpen(value:boolean){
        return (record:any)=>{
            const obj = record.data;

            return obj.isOpen === value;
        };
    }
    filterType(value:number){
        return (record:any)=>{
            const obj = record.data;

            return obj.type === value;
        };
    }
}